import { useState } from "react";
import { useSelector } from "react-redux";
import { Box, SwipeableDrawer, List, ListItemButton, ListItemIcon, ListItemText, Typography, Collapse } from "@mui/material";
import { FactCheck, EventNote, ExpandLess, ExpandMore, Home, Rule, Check, Wc, Assignment, Search, Apartment, CalendarMonth, Place, NearMe, School, AccountBox, EventAvailable, Assessment, People, SaveAs, PersonAddAlt, AddRoad, Badge, AltRoute, ArtTrack, AutoAwesomeMotion, Description, SupervisorAccount, Schema, Settings, Domain } from "@mui/icons-material";

import Image from '../../assets/udg.jpg';

const DropDownOptions = ({ open, options }) => {
    return(
        <Collapse in={open} timeout={'auto'} unmountOnExit>
            <List component={'div'} disablePadding>
                { options.map(({ text, onClick, icon }, i) => (
                    <ListItemButton key={i} sx={{ pl: 4 }} onClick={onClick}>
                        <ListItemIcon> {icon} </ListItemIcon>
                        <ListItemText primary={text} />
                    </ListItemButton>
                )) }
            </List>
        </Collapse>
    )
}

const TemporaryDrawer = ({ open, openDrawer, close, navigate }) => {
    const { type } = useSelector(state => state.auth);
    const [reportOptions, setReportOptions] = useState(false)
    const showReportOptions = () => setReportOptions(!reportOptions);
    
    const [userOptions, setUserOptions] = useState(false);
    const showUserOptions = () => setUserOptions(!userOptions);

    const [areasOptions, setAreasOptions] = useState(false);
    const showAreasOptions = () => setAreasOptions(!areasOptions);

    const [settingsOptions, setSettingsOptions] = useState(false);
    const showSettingsOptions = () => setSettingsOptions(prev => !prev);

    const redirectTo = (route) => {
        navigate(route)
        close()
    }
    const goToReport = (route) => {
        return redirectTo(route)
    }

    const areas = [
        { text: 'Áreas', onClick: () => redirectTo('/areas'), icon: <Domain />, dropDown: false, options: [], open: null},
        { text: 'Carreras', onClick: () => redirectTo('/carreras'), icon: <AddRoad />, dropDown: false, options: [], open: null},
        { text: 'Departamentos', onClick: () => redirectTo('/departamentos'), icon: <Apartment />, dropDown: false, options: [], open: null},
        { text: 'Supervisión', onClick: () => redirectTo('/supervision'), icon: <SupervisorAccount />, dropDown: false, options: [], open: null}
    ]

    const settings = [
        { text: 'Lugares', onClick: () => redirectTo('/lugares'), icon: <Place />, dropDown: false, options: [], open: null},
        { text: 'Modalidades', onClick: () => redirectTo('/modalidades'), icon: <AltRoute />, dropDown: false, options: [], open: null},
        { text: 'ODS', onClick: () => redirectTo('/ods'), icon: <AutoAwesomeMotion />, dropDown: false, options: [], open: null},
        { text: 'Sedes', onClick: () => redirectTo('/sedes'), icon: <NearMe />, dropDown: false, options: [], open: null},
        { text: 'Temáticas', onClick: () => redirectTo('/tematicas'), icon: <ArtTrack />, dropDown: false, options: [], open: null},
        { text: 'Tipos de eventos', onClick: () => redirectTo('/tipos'), icon: <Assignment />, dropDown: false, options: [], open: null},
    ]

    const reports = [
        { text: 'Asistencia', onClick: () => goToReport('/reporte/asistencia'), icon: <Description />},
        { text: 'Asistencia de Alumnos', onClick: () => redirectTo('/reporte/asistencia/alumnos'), icon: <Rule />},
        { text: 'Asistencia de Personal', onClick: () => redirectTo('/reporte/asistencia/personal'), icon: <FactCheck />},
        { text: 'Asistencia por Sexo', onClick: () => goToReport('/reporte/asistencia/sexo'), icon: <Wc />},
        { text: 'Eventos por Alumno', onClick: () => redirectTo('/reporte/eventos-alumnos'), icon: <EventNote />},
        { text: 'Histórico ODS', onClick: () => redirectTo('/reporte/ods'), icon: <AutoAwesomeMotion />},
        { text: 'Total de Eventos', onClick: () => redirectTo('/reporte/total/eventos'), icon: <Check />},
    ]

    const users = [
        { text: 'Administrativos', onClick: () => redirectTo('/administrativos'), icon: <Badge />},
        { text: 'Alumnos', onClick: () => redirectTo('/estudiantes'), icon: <School />},
        { text: 'Profesores', onClick: () => redirectTo('/profesores'), icon: <People />},
    ]

    const rootOptions = [
        { text: 'Perfil', onClick: () => redirectTo('/perfil'), icon: <Home />, dropDown: false, options: [], open: null},
        { text: 'Áreas', onClick: () => showAreasOptions(), icon: <Schema />, dropDown: true, options: areas, open: areasOptions},
        { text: 'Calendarios Escolares', onClick: () => redirectTo('/calendarios'), icon: <CalendarMonth />, dropDown: false, options: [], open: null},
        { text: 'Comunidad', onClick: () => showUserOptions(), icon: <AccountBox />, dropDown: true, options: users, open: userOptions},
        { text: 'Configuración', onClick: () => showSettingsOptions(), icon: <Settings />, dropDown: true, options: settings, open: settingsOptions},
        { text: 'Cuentas', onClick: () => redirectTo('/cuentas'), icon: <PersonAddAlt />, dropDown: false, options: [], open: null},
        { text: 'Eventos', onClick: () => redirectTo('/eventos'), icon: <EventAvailable />, dropDown: false, options: [], open: null},
        { text: 'Registro CSV', onClick: () => redirectTo('/csv'), icon: <SaveAs />, dropDown: false, options: [], open: null},
        { text: 'Reportes', onClick: () => showReportOptions(), icon: <Assessment />, dropDown: true, options: reports, open: reportOptions},
    ]
    const coordinatorOptions = [
        { text: 'Perfil', onClick: () => redirectTo('/perfil'), icon: <AccountBox />, dropDown: false, options: [], open: null},
        { text: 'Eventos', onClick: () => redirectTo('/eventos'), icon: <EventAvailable />, dropDown: false, options: [], open: null},
        { text: 'Alumnos', onClick: () => redirectTo('/estudiantes'), icon: <School />, dropDown: false, options: [], open: null},
        { text: 'Reporte Estudiantes', onClick: () => redirectTo('/estudiantes/reporte'), icon: <Assessment />, dropDown: false, options: [], open: null},
        { text: 'Reporte Asistencia', onClick: () => redirectTo('/eventos/reporte'), icon: <Rule />, dropDown: false, options: [], open: null},
        { text: 'Reporte Eventos', onClick: () => redirectTo('/eventos/reporte/general'), icon: <Check />, dropDown: false, options: [], open: null},
    ]
    const chiefsOptions = [
        { text: 'Perfil', onClick: () => redirectTo('/perfil'), icon: <AccountBox />, dropDown: false, options: [], open: null},
        { text: 'Eventos', onClick: () => redirectTo('/eventos'), icon: <EventAvailable />, dropDown: false, options: [], open: null},
        { text: 'Reporte Asistencia', onClick: () => redirectTo('/eventos/reporte'), icon: <Rule />, dropDown: false, options: [], open: null},
        { text: 'Reporte Eventos', onClick: () => redirectTo('/eventos/reporte/general'), icon: <Check />, dropDown: false, options: [], open: null},
        { text: 'Profesores', onClick: () => redirectTo('/profesores'), icon: <People />, dropDown: false, options: [], open: null},
    ]
    const defaultOptions = [
        { text: 'Perfil', onClick: () => redirectTo('/perfil'), icon: <AccountBox />, dropDown: false, options: [], open: null},
        { text: 'Eventos', onClick: () => redirectTo('/eventos'), icon: <EventAvailable />, dropDown: false, options: [], open: null},
        { text: 'Reporte Asistencia', onClick: () => redirectTo('/eventos/reporte'), icon: <Rule />, dropDown: false, options: [], open: null},
        { text: 'Reporte Eventos', onClick: () => redirectTo('/eventos/reporte/general'), icon: <Check />, dropDown: false, options: [], open: null},
    ]
    let options = null;

    switch (type) {
        case 'root':
            options = rootOptions
            break;
        case 'coordinator':
            options = coordinatorOptions;
            break;
        case 'bossDpt':
            options = chiefsOptions;
            break;
        case 'guest':
            options = defaultOptions;
            break;
        case 'supervisor':
            options = [ { text: 'Perfil', onClick: () => redirectTo('/perfil'), icon: <AccountBox />, dropDown: false, options: [], open: null}, ...reports];
            break;
        default:
            break;
    }
    return(
        <SwipeableDrawer
            anchor="left"
            open={open}
            onClose={close}
            onOpen={(e) => openDrawer(e) }
        >
            <Box
                sx={{ width: 250 }}
                role="presentation"
                onKeyDown={close}
            >
                <Typography 
                    component={'img'}
                    src={Image}
                    sx={{ width: '100%'}}
                    loading="lazy"
                    noWrap
                />
                <List>
                    <ListItemButton onClick={() => redirectTo('/buscar') }>
                        <ListItemIcon> {<Search />} </ListItemIcon>
                        <ListItemText primary={'Consulta tus eventos'} />
                    </ListItemButton>
                    { options ? options.map(({text, onClick, icon, dropDown, options, open}, i) => (
                        <div key={i}>
                            <ListItemButton onClick={onClick }>
                                <ListItemIcon> {icon} </ListItemIcon>
                                <ListItemText primary={text} />
                                { dropDown ? open ? <ExpandLess /> : <ExpandMore /> : null }
                            </ListItemButton>
                            { dropDown && <DropDownOptions open={open} options={options} /> }
                        </div >
                    )) : null}
                </List>
            </Box>
        </SwipeableDrawer>
    )
}

export default TemporaryDrawer;